import React, { useState, useRef, useEffect } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';
import { FaPaperPlane } from 'react-icons/fa';
import AIBuilderMessage from '../workflow/aibuilder/AIBuilderMessage';
import RamBotResultsWidget from './RamBotResultsWidget';

// RamBot's own chat panel (#2448) -- a simplified fork of AIBuilderChatPanel: no sample-file
// upload (not relevant to a search assistant), but each assistant message can carry structured
// tool data (toolName/data) rendered as a RamBotResultsWidget below its bubble, which
// AIBuilderChatPanel has no hook for. Same .ai-chat-* / .ai-bubble-* shared styling.
function RamBotChatPanel({ messages, inFlight, onSend, onOpenRunbook, onSendSuggestion, onExportRunbook, exporting }) {
  const [input, setInput] = useState('');
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages, inFlight]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = input.trim();
    if (!trimmed || inFlight) return;
    onSend(trimmed);
    setInput('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <div className="ai-chat-panel">
      <div className="ai-chat-scroll" ref={scrollRef}>
        {messages.map((m, i) => (
          <React.Fragment key={i}>
            <AIBuilderMessage role={m.role} kind={m.kind} content={m.content} />
            {m.role === 'assistant' && m.data && (
              <RamBotResultsWidget
                toolName={m.toolName}
                data={m.data}
                onOpenRunbook={onOpenRunbook}
                onSendSuggestion={onSendSuggestion}
                onExportRunbook={onExportRunbook}
                exporting={exporting}
              />
            )}
          </React.Fragment>
        ))}
        {inFlight && (
          <div className="ai-bubble-row ai-bubble-row-assistant">
            <div className="ai-bubble ai-bubble-assistant ai-bubble-typing">
              <Spinner animation="grow" size="sm" /> <Spinner animation="grow" size="sm" /> <Spinner animation="grow" size="sm" />
            </div>
          </div>
        )}
      </div>
      <Form onSubmit={handleSubmit} className="ai-chat-input-form">
        <div className="d-flex">
          <Form.Control
            as="textarea"
            rows={2}
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Which clients/runbooks use..."
            disabled={inFlight}
            className="ai-chat-input"
          />
          <Button
            type="submit"
            variant="primary"
            size="sm"
            disabled={!input.trim() || inFlight}
            className="ai-chat-send-btn ms-2"
          >
            <FaPaperPlane />
          </Button>
        </div>
      </Form>
    </div>
  );
}

export default RamBotChatPanel;
